import {
  IGetMessageByNoteIdArgs,
  INote,
  INoteMessage
} from "../../../pages/content-viewer/notes-widget/notes-slice/notesType";
import { AuthoringDashboardArgs } from "./authoringDashboardArgs";
import { SearchCatalogArgs } from "./searchCatalog";

export interface QueryArgsSlice {
  searchCatalogArgs: SearchCatalogArgs;
  authoringCatalogArgs: AuthoringDashboardArgs;
  upsertNote: Partial<INote>;
  upsertNoteMessage: Partial<INoteMessage>;
  getNotesArgs: IGetMessageByNoteIdArgs;
  noteId?: string;
  isNoteEdit: boolean;
}

export const initialState: QueryArgsSlice = {
  searchCatalogArgs: {
    pageSize: 12,
    pageNumber: 1,
    relevance: false,
    sortKey: "_score",
    requestDto: {
      indices: [
        "tms",
        "content",
        "lynda",
        "imocha",
        "learningpath",
        "content_modified",
        "course",
        "method_episode",
        "method_podcast",
        "practices",
        "assessment-schedule"
      ],
      searchRequest: "",
      filters: {},
      smartSearch: true
    },
    sortOrder: "DESC"
  },
  authoringCatalogArgs: {
    pageSize: 12,
    pageNumber: 1,
    relevance: false,
    sortKey: "_score",
    requestDto: {
      indices: [
        "tms",
        "content_modified",
        "content",
        "lynda",
        "imocha",
        "learningpath"
      ],
      searchRequest: "",
      filters: {},
      smartSearch: false,
      stakeHolder: {}
    },
    sortOrder: "DESC"
  },
  upsertNote: {},
  upsertNoteMessage: {
    text: "",
    type: "noteMessageType1",
    attachments: [],
    archived: false,
    isFavourite: false
  },
  getNotesArgs: {
    pageNumber: 0,
    pageSize: 10,
    sortKey: "updatedat",
    sortOder: "DESC",
    noteId: ""
  },
  noteId: undefined,
  isNoteEdit: false
};
